import { employeeProfileHref, isSideNavLayout } from "@performyard/utils-isomorphic";

const EmployeeURL = (employeeId?: string): string => employeeProfileHref(employeeId);

// Under the new side navigation, clicking your own name lands on your dashboard instead of
// your details page; legacy navigation links to the dashboard either way.
export const employeeNameLink = (employeeId?: string, currentUserId?: string): string =>
	isSideNavLayout() && currentUserId && employeeId === currentUserId ? "/" : employeeProfileHref(employeeId);

export default EmployeeURL;
